import { render } from "./TheFooterBar.vue?vue&type=template&id=23b0f8ac&scoped=true&ts=true"
import script from "./TheFooterBar.vue?vue&type=script&lang=ts"
export * from "./TheFooterBar.vue?vue&type=script&lang=ts"

import "./TheFooterBar.vue?vue&type=style&index=0&id=23b0f8ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b0f8ac"]])

export default __exports__